import React from 'react';
import { Percent, Clock, Tag } from 'lucide-react';
import { cn } from '../lib/utils';

export function DiscountSelector({ 
  manualDiscount, 
  volumeDiscount, 
  availableDiscounts,
  durationHours,
  onManualDiscountChange 
}) {
  return (
    <div className="space-y-4">
      {/* Volume Discount Info */}
      {volumeDiscount > 0 && (
        <div className="flex items-center gap-3 p-3 rounded-lg bg-green-500/10 border border-green-500/30">
          <Clock className="w-5 h-5 text-green-400" />
          <div>
            <p className="text-sm font-medium text-green-400">
              ¡Descuento por volumen aplicado!
            </p>
            <p className="text-xs text-green-300/70">
              {volumeDiscount}% de descuento automático por duración mayor a {
                durationHours >= 11 ? '11' : durationHours >= 9 ? '9' : durationHours >= 7 ? '7' : '5'
              } horas
            </p>
          </div>
        </div>
      )}

      {/* Manual Discount Selection */}
      <div className="space-y-2">
        <div className="flex items-center gap-2 text-slate-300">
          <Tag className="w-4 h-4 text-[#aa2aff]" />
          <span className="text-sm font-medium">Descuento Adicional</span>
        </div>
        
        <div className="flex gap-2">
          <button
            onClick={() => onManualDiscountChange(0)}
            data-testid="btn-discount-none"
            className={cn(
              "flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-all",
              manualDiscount === 0
                ? "bg-[#aa2aff] text-white shadow-lg"
                : "bg-white/5 text-slate-400 hover:bg-white/10 border border-white/10"
            )}
          >
            Sin descuento
          </button>
          
          {availableDiscounts.map((discount) => (
            <button
              key={discount}
              onClick={() => onManualDiscountChange(discount)}
              data-testid={`btn-discount-${discount}`}
              className={cn(
                "flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-1",
                manualDiscount === discount
                  ? "bg-[#aa2aff] text-white shadow-lg"
                  : "bg-white/5 text-slate-400 hover:bg-white/10 border border-white/10"
              )}
            >
              <Percent className="w-3 h-3" />
              {discount}%
            </button>
          ))}
        </div>
      </div>

      {/* Total discount summary */}
      {(volumeDiscount > 0 || manualDiscount > 0) && (
        <div className="flex items-center justify-between p-3 rounded-lg bg-[#aa2aff]/10 border border-[#aa2aff]/30">
          <span className="text-sm text-[#aa2aff]">Descuento total aplicado:</span>
          <span className="text-lg font-bold text-[#aa2aff]">
            {volumeDiscount + manualDiscount}%
          </span>
        </div>
      )}
    </div>
  );
}

export default DiscountSelector;
